import React, { useEffect, useState } from 'react';
import { Image, ImageProps, Skeleton } from '@chakra-ui/react';

interface AuthenticatedImageProps extends ImageProps {
  url: string;
  token?: string;
}

export const AuthenticatedImage: React.FC<AuthenticatedImageProps> = ({ url, token, ...props }) => {
  const [src, setSrc] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    // CloudFront URLs are already signed, use them directly
    // No need for authentication or blob conversion
    if (url) {
      setSrc(url);
      setLoading(false);
    }
  }, [url]);

  if (loading) return <Skeleton w={props.w || "50px"} h={props.h || "50px"} borderRadius={props.borderRadius || "md"} />;
  if (error) return <Image src={url} fallbackSrc="https://via.placeholder.com/50?text=!" {...props} />;

  return <Image src={src || undefined} {...props} />;
};
